'use client';

import React, { useState } from 'react';

import { getCookie, setCookie } from 'cookies-next/client';

import { LocationContext } from './LocationContext';
import { CurrencyCode, locations, type SupportedLocation } from './constants';

import { NEXT_LOCALE_KEY } from '@/constants/cookies';

type Props = {
  children: React.ReactNode;
  initialLocation?: SupportedLocation;
};

function LocationProvider({ initialLocation, children }: Props) {
  const {
    NEXT_PUBLIC_DEFAULT_LOCATION: defaultLocation,
    NEXT_PUBLIC_LOCALISED_ROUTES,
  } = process.env;

  const localisedRoutes = NEXT_PUBLIC_LOCALISED_ROUTES?.split(' ') || [];

  const defaultInitialLocation =
    initialLocation ||
    (getCookie(NEXT_LOCALE_KEY) as SupportedLocation) ||
    defaultLocation;

  const [currentLocation, setCurrentLocation] = useState<SupportedLocation>(
    defaultInitialLocation
  );

  function getCurrencyCodeByLocation() {
    const userLocation = locations.find((loc) => loc.value === currentLocation);
    return userLocation?.defaultCurrency || CurrencyCode.USD;
  }

  function setLocation(newLocation: SupportedLocation) {
    setCookie(NEXT_LOCALE_KEY, newLocation);
    setCurrentLocation(newLocation);
  }

  return (
    <LocationContext.Provider
      value={{
        defaultLocation,
        location: currentLocation,
        getCurrencyCodeByLocation,
        setLocation,
        localisedRoutes,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
}

export { LocationProvider };
